<template>
    <div class="p-col-10 p-grid p-mx-auto p-mt-1">
        <div class="p-col-12 p-md-2 box">
            <h2>Tournament Type</h2>

            <div class="p-grid">
                <div class="p-col-12">
                    <h3 class="p-text-center">Categories</h3>
                    <Listbox v-model="selected.event_tournament.category"
                        :options="categories.items"
                        :filter="true"
                        optionLabel="label"
                        class="p-text-left"
                        @change="eventTournamentCategorySelected()"
                        listStyle="max-height:250px" />

                    <h3 v-if="categories.isReady && selected.event_tournament.tournamentList !== null" class="p-text-center p-mt-4">Tournaments</h3>
                    <Listbox v-model="selected.event_tournament.tournament"
                        v-if="categories.isReady && selected.event_tournament.tournamentList !== null"
                        :options="selected.event_tournament.tournamentList"
                        optionLabel="name"
                        class="p-text-left p-mt-2"
                        listStyle="max-height:300px" />
                </div>
            </div>
        </div>
        <div class="p-col-12 p-md-5 box">
            <h2>Home Team</h2>

            <div class="p-grid">
                <div class="p-col-6">
                    <h3 class="p-text-center">Categories</h3>
                    <Listbox v-model="selected.home.category"
                        :options="categories.items"
                        :filter="true"
                        optionLabel="label"
                        class="p-text-left"
                        @change="homeAwayCategorySelected('home')"
                        listStyle="max-height:250px" />

                    <h3 v-if="categories.isReady && selected.home.tournamentList !== null" class="p-text-center p-mt-4">Tournaments</h3>
                    <Listbox v-model="selected.home.tournament"
                        v-if="categories.isReady && selected.home.tournamentList !== null"
                        :options="selected.home.tournamentList"
                        optionLabel="name"
                        class="p-text-left p-mt-2"
                        @change="homeAwayTournamentSelected('home')"
                        listStyle="max-height:100px" />

                    <h3 v-if="categories.isReady && selected.home.seasonList !== null" class="p-text-center p-mt-4">Seasons</h3>
                    <Listbox v-model="selected.home.season"
                        v-if="categories.isReady && selected.home.seasonList !== null"
                        :options="selected.home.seasonList"
                        optionLabel="name"
                        class="p-text-left p-mt-2"
                        @change="homeAwaySeasonSelected('home')"
                        listStyle="max-height:100px" />
                </div>
                <div class="p-col-6">
                    <h3 v-if="categories.isReady && selected.home.teamList !== null" class="p-text-center">Teams</h3>
                    <Listbox v-model="selected.home.team"
                        v-if="categories.isReady && selected.home.teamList !== null"
                        :filter="true"
                        :options="selected.home.teamList"
                        optionLabel="name"
                        class="p-text-left"
                        listStyle="max-height:450px" />
                </div>
            </div>
        </div>
        <div class="p-col-12 p-md-5 box">
            <h2>Away Team</h2>

            <div class="p-grid">
                <div class="p-col-6">
                    <h3 class="p-text-center">Categories</h3>
                    <Listbox v-model="selected.away.category"
                        :options="categories.items"
                        :filter="true"
                        optionLabel="label"
                        class="p-text-left"
                        @change="homeAwayCategorySelected('away')"
                        listStyle="max-height:250px" />

                    <h3 v-if="categories.isReady && selected.away.tournamentList !== null" class="p-text-center p-mt-4">Tournaments</h3>
                    <Listbox v-model="selected.away.tournament"
                        v-if="categories.isReady && selected.away.tournamentList !== null"
                        :options="selected.away.tournamentList"
                        optionLabel="name"
                        class="p-text-left p-mt-2"
                        @change="homeAwayTournamentSelected('away')"
                        listStyle="max-height:100px" />

                    <h3 v-if="categories.isReady && selected.away.seasonList !== null" class="p-text-center p-mt-4">Seasons</h3>
                    <Listbox v-model="selected.away.season"
                        v-if="categories.isReady && selected.away.seasonList !== null"
                        :options="selected.away.seasonList"
                        optionLabel="name"
                        class="p-text-left p-mt-2"
                        @change="homeAwaySeasonSelected('away')"
                        listStyle="max-height:100px" />
                </div>
                <div class="p-col-6">
                    <h3 v-if="categories.isReady && selected.away.teamList !== null" class="p-text-center">Teams</h3>
                    <Listbox v-model="selected.away.team"
                        v-if="categories.isReady && selected.away.teamList !== null"
                        :filter="true"
                        :options="selected.away.teamList"
                        optionLabel="name"
                        class="p-text-left"
                        listStyle="max-height:450px" />
                </div>
            </div>
        </div>
        <div class="p-col-12 p-mt-4 box">
            <div class="p-grid">
                <div class="p-col-8 p-text-center">
                    <h3>
                        {{result.message}}
                    </h3>
                </div>
                <div class="p-col-4 p-text-right">
                    <Button label="Search" @click="search()" />
                </div>
                <div class="p-col-8 p-pl-2">
                    <div class="p-fluid p-text-left">
                        <div class="p-field">
                            <label for="image_url">Image Url</label>
                            <InputText id="image_url" class="" type="text" v-model="selected.searchResult.imageUrl" />
                        </div>
                    </div>
                    <div class="p-fluid p-text-left p-mt-4">
                        <span class="p-float-label">
                            <Textarea class="" id="comment" type="text" rows="3" :autoResize="true" v-model="selected.searchResult.comment" style="width: 100%;" />
                            <label for="comment">Comment</label>
                        </span>
                    </div>
                </div>
                <div class="p-col-4 p-mt-4">
                    <div class="p-field p-text-center" v-show="selected.searchResult.imageUrl !== null && selected.searchResult.imageUrl !== undefined && selected.searchResult.imageUrl !== ''">
                        <Image imageClass="notification-picture" style="width:100% !important;" preview :src="selected.searchResult.imageUrl" />
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12 p-mt-4 box">
            <div class="p-grid">
                <div class="p-col-8 p-text-left">
                    <Button label="Delete" @click="deleteSearchResult()" class="p-button-outlined p-button-danger" />
                </div>
                <div class="p-col-4 p-text-right">
                    <Button label="Save changes" @click="save()" class="p-button-raised p-button-success" />
                </div>
            </div>
        </div>
    </div>

    <Divider align="center" class="p-mt-6">
        <div class="p-d-inline-flex p-ai-center">
        <b>About</b>
        </div>
    </Divider>

    <div class="p-col-12 p-md-9 p-mx-auto p-mt-2 p-text-left">
        <div class="p-d-flex">
            <i class="fa fa-info p-mr-3"></i> News Lineups Draft'lara otomatik olarak Scheduled Job ile eklenecek kayıtlar için home/away takımları için varsayılan haber görseli girilmesinde kullanılır. <br/>
            Turnuva bazlı olarak iki takım için farklı görseller girilebilir. <br/>
            Örneğin, Galatasaray-Fenerbahçe maçı için Süper Lig'de farklı, Türkiye Kupası'nda farklı görseller kullanılabilir.
        </div>
    </div>

</template>

<style>
.notification-picture {
    float: left;
    width: 100%;
    height: 100px;
    object-fit: contain;
    text-align: center;
    border-radius: 4px;
}
</style>

<script>
import axios from "axios";
import Button from 'primevue/button'
import Divider from 'primevue/divider'
import Listbox from 'primevue/listbox'
import Image from 'primevue/image'
import Textarea from 'primevue/textarea'

let SpringApi;

export default {
    name: 'EventImageBackgrounds',
    emits: ["loginResult", "pageLoaded"],
    components: {
        Divider, Button, Listbox, Image, Textarea
    },
    data() {
        return {
            result: {
                message: null,
                eventImageBackground: null
            },
            categories: { 
                // event, home, away için categories tek listede bulunacak
                // category seçimi yapıldığında, category[x].tournaments boş ise;
                // tournaments yüklenecek ve category[x].tournaments = ... şeklinde set edilecek
                items: [],
                isReady: false
            },
            selected: {
                event_tournament: {
                    category: null, // event_tournament için category seçilince buraya set edilecek
                    tournamentList: null, // event_tournament için; seçilen categorynin turnuvaları set edilecek
                    tournament: null, // event_tournament için tournament seçilince buraya set edilecek
                },
                home: {
                    category: null, // home için category seçilince buraya set edilecek
                    tournamentList: null, // home için seçilen categorynin turnuvaları set edilecek
                    tournament: null, // home için tournament seçilince buraya set edilecek
                    seasonList: null, // home için seçilen turnuvanın sezonları set edilecek
                    season: null, // home için seçilen turnuvanın seçilen sezonu
                    teamList: null, // home için sezon seçilince takım listesi buraya set edilecek
                    team: null, // home için team seçilince buraya set edilecek
                },
                away: {
                    category: null, // away için category seçilince buraya set edilecek
                    tournamentList: null, // away için seçilen categorynin turnuvaları set edilecek
                    tournament: null, // away için tournament seçilince buraya set edilecek
                    seasonList: null, // away için seçilen turnuvanın sezonları set edilecek
                    season: null, // away için seçilen turnuvanın seçilen sezonu
                    teamList: null, // away için sezon seçilince takım listesi buraya set edilecek
                    team: null, // away için team seçilince buraya set edilecek
                },
                searchResult: {} // search ile bulunan item set edilecek
            },
        }
    },
    beforeMount() {
        SpringApi = axios.create({
            baseURL : process.env.VUE_APP_SPRING_API_URL,
            headers: {
                'Authorization': 'Bearer ' + this.$cookies.get('token')
            }
        });

        var page = {
            title: "Event Image Backgrounds"
        }
        this.$emit('pageLoaded', page)
    },
    mounted() {
        this.getCategories()
    },
    methods: {
        async getCategories() {
            let categories = await SpringApi.get('/ss/categories')
            this.categories.items = categories.data.map(it => {
                return {...it, label: '[' + it.id + '] - ' + it.name}
            });
            this.categories.isReady = this.categories.items !== null && this.categories.items.length > 0
        },
        async getTournaments(categoryId) {
            let tournaments = await SpringApi.get('/ss/categories/'+categoryId+'/unique-tournaments')
            return tournaments
        },
        async getSeasons(uniqueTournamentId) {
            let seasons = await SpringApi.get('/ss/unique-tournaments/'+uniqueTournamentId+'/seasons')
            return seasons
        },
        async getTeams(uniqueTournamentId, seasonId) {
            let teams = await SpringApi.get('/ss/unique-tournaments/'+uniqueTournamentId+'/seasons/'+seasonId+'/teams')
            return teams
        },
        async eventTournamentCategorySelected() {
            // mevcut turnuvaları ve mevcutta seçili olan event_tournament değerini temizle
            this.selected.event_tournament.tournamentList = null
            this.selected.event_tournament.tournament = null

            // seçilen kategorinin turnuva seçeneklerini getir
            let selectedCategory = this.selected.event_tournament.category
            if (selectedCategory === null) return null

            let tournaments = await this.getTournaments(selectedCategory.id)
            this.selected.event_tournament.tournamentList = tournaments.data
        },
        async homeAwayCategorySelected(homeOrAway) {
            let selection = homeOrAway === 'home' ? this.selected.home : this.selected.away

            // mevcut seçimleri temizle
            selection.tournamentList = null
            selection.tournament = null
            selection.seasonList = null
            selection.season = null
            selection.team = null

            // seçilen kategorinin turnuva seçeneklerini getir
            let selectedCategory = selection.category
            if (selectedCategory === null) return null

            let tournaments = await this.getTournaments(selectedCategory.id)
            selection.tournamentList = tournaments.data
        },
        async homeAwayTournamentSelected(homeOrAway) {
            let selection = homeOrAway === 'home' ? this.selected.home : this.selected.away

            // mevcut seçimleri temizle
            selection.seasonList = null
            selection.season = null
            selection.team = null

            // seçilen turnuvanın sezon seçeneklerini getir
            let selectedTournament = selection.tournament
            if (selectedTournament === null) return null

            let seasons = await this.getSeasons(selectedTournament.id)
            selection.seasonList = seasons.data
        },
        async homeAwaySeasonSelected(homeOrAway) {
            let selection = homeOrAway === 'home' ? this.selected.home : this.selected.away

            // mevcut seçimleri temizle
            selection.team = null

            // seçilen turnuvanın seçilen sezonuna ait takım listesini getir
            let selectedTournament = selection.tournament
            let selectedSeason = selection.season
            if (selectedTournament === null || selectedSeason === null) return null

            let teams = await this.getTeams(selectedTournament.id, selectedSeason.id)
            selection.teamList = teams.data
        },
        async search() {
            this.setResultMessage(null)
            this.selected.searchResult = {};

            let selectedEventTournament = this.selected.event_tournament.tournament
            if (selectedEventTournament === null || selectedEventTournament === undefined) {
                this.setResultMessage('Event Tournament Type is not selected'); return;
            }

            let selectedHomeTeam = this.selected.home.team
            if (selectedHomeTeam === null || selectedHomeTeam === undefined) {
                this.setResultMessage('Home Team is not selected'); return;
            }

            let selectedAwayTeam = this.selected.away.team
            if (selectedAwayTeam === null || selectedAwayTeam === undefined) {
                this.setResultMessage('Away Team is not selected'); return;
            }

            try {
                let searchResponse = await SpringApi.get('/event-image-backgrounds/search?ssUniqueTournamentId='+selectedEventTournament.id+'&ssHomeTeamId='+selectedHomeTeam.id+'&ssAwayTeamId='+selectedAwayTeam.id)
                if (searchResponse !== null) {
                    this.selected.searchResult = searchResponse.data;
                } else {
                    this.setResultMessage('Not found');
                }
            } catch(error) {
                console.log(error)
                this.setResultMessage('Not found');
            }
        },
        async save() {
            let searchResult = this.selected.searchResult,
                tournament = this.selected.event_tournament.tournament,
                homeTeam = this.selected.home.team,
                awayTeam = this.selected.away.team,
                toast = this.$toast,
                message = null;

            if (tournament === undefined || tournament === null) {
                message = 'Event Tournament is not selected';
            } else if (homeTeam === undefined || homeTeam === null) {
                message = 'Home Team is not selected';
            } else if (awayTeam === undefined || awayTeam === null) {
                message = 'Away Team is not selected';
            } else if (searchResult === undefined || searchResult === null
                || searchResult.imageUrl === undefined || searchResult.imageUrl === null) {
                message = 'Image Url is empty';
            }

            if (message !== null) {
                toast.add({severity:'warn', summary: 'Error!', detail:message, life: 3000});
                return;
            }

            let requestBody = {
                ssUniqueTournamentId: tournament.id,
                ssHomeTeamId: homeTeam.id,
                ssAwayTeamId: awayTeam.id,
                imageUrl: searchResult.imageUrl,
                comment: searchResult.comment
            };
            
            var response;
            if (searchResult.id !== undefined && searchResult.id !== null) {
                // update
                response = await SpringApi.put('/event-image-backgrounds/'+searchResult.id, requestBody)
            } else {
                // insert
                response = await SpringApi.post('/event-image-backgrounds', requestBody)
            }

            if(response.status >= 200 && response.status <= 299) {
                toast.add({severity: 'success', summary: 'Successful', detail: 'Event image background saved', life: 1500});
            } else {
                toast.add({severity: 'error', summary: 'Error', detail: 'Event image background save failed', life: 3000});
                console.log(response)
            }
        },
        deleteSearchResult() {
            let searchResult = this.selected.searchResult,
                toast = this.$toast,
                tournament = this.selected.event_tournament.tournament,
                homeTeam = this.selected.home.team,
                awayTeam = this.selected.away.team,
                message = null;

            if (tournament === undefined || tournament === null) {
                message = 'Event Tournament is not selected';
            } else if (homeTeam === undefined || homeTeam === null) {
                message = 'Home Team is not selected';
            } else if (awayTeam === undefined || awayTeam === null) {
                message = 'Away Team is not selected';
            } if (searchResult === undefined || searchResult === null
                || searchResult.id === undefined || searchResult.id === null) {
                message = 'Event Image is not selected or it is not found!';
            }

            if (message !== null) {
                toast.add({severity:'warn', summary: 'Error!', detail:message, life: 3000});
                return;
            }

            this.$confirm.require({
                message: 'Delete the event image background?\n'+tournament.name+' ['+homeTeam.name+' - '+awayTeam.name+']',
                header: 'Delete',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Delete',
                rejectLabel: 'Cancel',
                accept: async () => {
                    try {
                        let response = await SpringApi.delete('/event-image-backgrounds/'+searchResult.id)
                        if(response.status >= 200 && response.status <= 299) {
                            this.selected.searchResult.id = null;
                            toast.add({severity: 'success', summary: 'Successful', detail: 'Event image background deleted', life: 1500});
                        } else {
                            toast.add({severity: 'error', summary: 'Error', detail: 'Event image background delete failed', life: 3000});
                            console.log(response)
                        }
                    } catch(error) {
                        toast.add({severity: 'error', summary: 'Error', detail: 'Event image background delete failed', life: 3000});
                        console.log(error)
                    }
                },
                reject: () => {
                }
            });

            console.log('delete')
        },
        setResultMessage(message) {
            this.result.message = message
        }
    }
}
</script>
